import { auth } from "@/firebase/firebaseConfig";
import {
  browserLocalPersistence,
  browserSessionPersistence,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
  updateProfile
} from "firebase/auth";

export async function registerAuth(email, password, fullName) {
  try {
    if (!email || !password) {
      throw new Error("Email e senha são obrigatórios");
    }
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    
    // Salva o nome completo no Firebase Auth
    if (fullName) {
      await updateProfile(userCredential.user, { displayName: fullName });
    }

    return userCredential.user;
  } catch (error) {
    console.error("Erro ao registrar usuário:", error);
    throw error;
  }
}

export async function loginAuth(email, password, rememberMe = true) {
  try {
    const persistence = rememberMe ? browserLocalPersistence : browserSessionPersistence
    await setPersistence(auth, persistence)
    const userCredential = await signInWithEmailAndPassword(auth, email, password)
    return userCredential.user
  } catch (error) {
    console.error("Erro ao fazer login:", error)
    throw error
  }
}

export async function logoutAuth() {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Erro ao fazer logout:", error);
    throw error;
  }
}

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      auth,
      (user) => { removeListener(); resolve(user); },
      (error) => { removeListener(); reject(error); }
    );
  });
};